import React from "react";
import createSvgIcon from "@material-ui/core/utils/createSvgIcon";

/**
 * author: Austin Andrews
 * id 882DF0E2-C223-4B3F-A538-81EC05421BA9
 * name music-note-sixteenth
 * version: 1.5.54
 * url https://raw.githubusercontent.com/Templarian/MaterialDesign/master/svg/music-note-sixteenth.svg
 * tags
 * - Audio 
 * - Music 
 */
export const MusicNoteSixteenthIcon = createSvgIcon(<><path d="M18 7V3H12V13.55C11.41 13.21 10.73 13 10 13C7.79 13 6 14.79 6 17S7.79 21 10 21 14 19.21 14 17V11H18V8H14V7H18Z" /></>, 'MusicNoteSixteenthIcon');
export default MusicNoteSixteenthIcon